export default {
      id: "presence-dnd-usage",
      viewBox: "0 0 10 10",
      url: "/dist/svg/" + "sprite.svg#presence-dnd-usage",
      toString: function () {
        return this.url;
      }
    }